import React, { useState } from 'react';
import BookingCard from './BookingCard';
import { bookingsService } from '../../services/api';
import styles from './CheckinList.module.css';

const CheckinList = ({ data, onRefresh }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!data) {
    return <div className={styles.loading}>Loading check-in data...</div>;
  }

  const filtered = data.checkins.filter((b) =>
    searchTerm
      ? b.bookingNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        b.guestName.toLowerCase().includes(searchTerm.toLowerCase())
      : true
  );

  const handleCheckin = async (bookingId) => {
    try {
      await bookingsService.checkIn(bookingId);
      alert('Guest checked in successfully');
      onRefresh();
    } catch (error) {
      console.error('Check-in failed:', error);
      const errorMessage = error.error || error.message || 'Failed to check in booking';
      alert(`${errorMessage}`);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.summary}>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Total</span>
          <strong className={styles.statValue}>{data.totalCheckins}</strong>
        </div>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Pending</span>
          <strong className={`${styles.statValue} ${styles.pending}`}>
            {data.pendingCheckins}
          </strong>
        </div>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Completed</span>
          <strong className={`${styles.statValue} ${styles.completed}`}>
            {data.totalCheckins - data.pendingCheckins}
          </strong>
        </div>
      </div>

      <div className={styles.controls}>
        <input
          type="text"
          placeholder="Search by booking number or guest name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.search}
        />
      </div>

      <div className={styles.list}>
        {filtered.length === 0 ? (
          <div className={styles.empty}>
            {data.pendingCheckins === 0 ? (
              <p>All check-ins completed!</p>
            ) : (
              <p>No bookings match your search</p>
            )}
          </div>
        ) : (
          filtered.map((booking) => (
            <BookingCard
              key={booking.id}
              booking={booking}
              action={
                booking.status !== 'CHECKEDIN' ? (
                  <button
                    className={styles.actionButton}
                    onClick={() => handleCheckin(booking.id)}
                  >
                    Check In
                  </button>
                ) : (
                  <span className={styles.done}>Checked In</span>
                )
              }
            />
          ))
        )}
      </div>
    </div>
  );
};

export default CheckinList;
